import type { LeadId, LeadPipelineStage } from "./crm";

export type AdminLeadDuplicateCursor = string & {
  readonly __brand: "AdminLeadDuplicateCursor";
};
export type AdminLeadDuplicateCandidateSetRevision = string & {
  readonly __brand: "AdminLeadDuplicateCandidateSetRevision";
};

export const adminLeadDuplicatePageSizes = [25] as const;
export type AdminLeadDuplicatePageSize =
  (typeof adminLeadDuplicatePageSizes)[number];

export const adminLeadDuplicateEligibilities = [
  "ELIGIBLE",
  "TARGET_INACTIVE",
] as const;
export type AdminLeadDuplicateEligibility =
  (typeof adminLeadDuplicateEligibilities)[number];

export const adminLeadDuplicateMatchKinds = ["EMAIL", "PHONE"] as const;
export type AdminLeadDuplicateMatchKind =
  (typeof adminLeadDuplicateMatchKinds)[number];

export const adminLeadDuplicateCandidateSetRevisionMaxLength = 256;
export const adminLeadDuplicateCursorMaxLength = 512;

export interface AdminLeadDuplicateSummary {
  readonly eligibility: AdminLeadDuplicateEligibility;
  readonly candidateContactCount: number;
  readonly matchKinds: readonly AdminLeadDuplicateMatchKind[];
}

export interface AdminLeadDuplicateCandidate {
  readonly representativeLeadId: LeadId;
  readonly displayName: string;
  readonly matchKinds: readonly AdminLeadDuplicateMatchKind[];
  readonly activeLeadCount: number;
  readonly pipelineStage: LeadPipelineStage;
  readonly representativeLeadCreatedAt: string;
}

export interface AdminLeadDuplicateQuery {
  readonly leadId: LeadId;
  readonly cursor: AdminLeadDuplicateCursor | null;
  readonly limit: AdminLeadDuplicatePageSize;
}

export interface AdminLeadDuplicatePage {
  readonly leadId: LeadId;
  readonly candidateSetRevision: AdminLeadDuplicateCandidateSetRevision;
  readonly summary: AdminLeadDuplicateSummary;
  readonly items: readonly AdminLeadDuplicateCandidate[];
  readonly nextCursor: AdminLeadDuplicateCursor | null;
}
